import createLucideIcon from '../createLucideIcon';

const ArrowUpToLine = createLucideIcon('ArrowUpToLine', [
  ['line', { x1: '12', x2: '12', y1: '7', y2: '21', key: 'mhahpb' }],
  ['polyline', { points: '18 13 12 7 6 13', key: '9nrmn7' }],
  ['path', { d: 'M5 3h14', key: '7usisc' }],
]);

export default ArrowUpToLine;
